import React, { FormEvent } from "react";
import { ChatMessage } from "../game-modes/BattleArena";


export interface ChatProps {
  showChat: boolean;
  setShowChat: (show: boolean) => void;
  chatMessages: ChatMessage[];
  newChatMessage: string;
  setNewChatMessage: (msg: string) => void;
  handleChatSubmit: (e: FormEvent<HTMLFormElement>) => void;
  chatInputRef: React.RefObject<HTMLInputElement | null>;
  chatContainerRef: React.RefObject<HTMLDivElement | null>;
  currentUser: { userId: string } | null;
}

export const ChatComponent: React.FC<ChatProps> = React.memo(({
  showChat,
  setShowChat,
  chatMessages,
  newChatMessage,
  setNewChatMessage,
  handleChatSubmit,
  chatInputRef,
  chatContainerRef,
  currentUser
}) => (
  <div
    className={`fixed bottom-0 right-0 w-72 md:w-80 ${showChat ? "h-64 md:h-96" : "h-12"} bg-gray-800 border border-gray-700 rounded-tl-md shadow-lg transition-all duration-300 flex flex-col z-50`}
    onKeyDown={(e) => e.stopPropagation()}
  >
    {/* Chat header */}
    <div
      className="flex justify-between items-center p-3 bg-gray-700 rounded-tl-md cursor-pointer"
      onClick={() => setShowChat(!showChat)}
    >
      <div className="flex items-center">
        <span className="text-white font-medium">Battle Chat</span>
        {!showChat && chatMessages.length > 0 && (
          <span className="ml-2 bg-blue-600 text-white text-xs rounded-full px-2 py-0.5">
            {chatMessages.length}
          </span>
        )}
      </div>
      <button className="text-gray-300 hover:text-white focus:outline-none">
        {showChat ? "▼" : "▲"}
      </button>
    </div>

    {/* Chat messages */}
    {showChat && (
      <>
        <div
          ref={chatContainerRef}
          className="flex-1 overflow-y-auto p-3 space-y-2"
        >
          {chatMessages.length === 0 ? (
            <div className="text-gray-500 text-center text-sm p-2">
              <p>No messages yet</p>
              <p className="text-xs mt-1">Press T to quickly open chat</p>
            </div>
          ) : (
            chatMessages.map((msg, idx) => (
              <div
                key={`msg-${idx}-${msg.timestamp}`}
                className={`p-2 rounded-md max-w-[80%] ${
                  msg.senderId === currentUser?.userId
                    ? "bg-blue-800 ml-auto"
                    : "bg-gray-700"
                }`}
              >
                <div className="text-xs text-gray-400">
                  {msg.senderName}
                </div>
                <div className="text-white break-words">{msg.message}</div>
              </div>
            ))
          )}
        </div>

        {/* Chat input */}
        <form
          onSubmit={handleChatSubmit}
          className="p-2 border-t border-gray-700 flex"
        >
          <input
            ref={chatInputRef}
            value={newChatMessage}
            onChange={(e) => setNewChatMessage(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()}
            placeholder="Type message..."
            className="flex-1 bg-gray-700 text-white p-2 rounded-l-md focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white px-3 rounded-r-md focus:outline-none"
          >
            Send
          </button>
        </form>
      </>
    )}
  </div>
));

